<template lang="pug">
div(v-if="usuarioLogado && cadastroFormulario && cadastroFormulario.cadastrante")
  el-row.radio-buttons(:gutter="30" v-if="tipoCadastro === 'NAO_ONEROSO'")
    el-col.inputDiv(:span="8")
      el-radio(v-model="radio" :label="true" @change="changeTipoCadastrante") Pessoa Física
      el-radio(v-model="radio" :label="false" @change="changeTipoCadastrante") Pessoa Jurídica
  div(v-if="radio")
    el-row.labelDiv(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(rules="required|cpf", v-slot="{ errors }", :name="nomeAba + '/Cpf'")
          app-label(label="CPF:", :required="true")
          el-input.input(
            name="cadastroChange"
            v-model="cadastroFormulario.cadastrante.pessoa.pessoaFisica.cpf",
            v-mask="['###.###.###-##', '##.###.###/####-##']",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="16")
        validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome/Razão social'")
          app-label(label="Nome:", :required="true")
          el-input.input(
            maxlength="300"
            v-model="cadastroFormulario.cadastrante.pessoa.pessoaFisica.nome",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    el-row.labelDiv(:gutter="30" v-if="tipoCadastro === 'ONEROSO'" style="padding: 20px 0")
      el-col.inputDiv(:span="8")
        app-input-telefone(
          :telefones="telefones",
          :nomeAba="nomeAba",
          :requiredTelefones="true"
          :observer="observer"
        )
      el-col.inputDiv(:span="16")
        validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/E-mail do cadastrante'")
          app-label(label="E-mail:", :required="true")
          el-input.input(
            name="E-mail",
            v-model="cadastroFormulario.cadastrante.pessoa.email",
            maxlength="100"
            label='email',
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
  div(v-else)
    el-row.labelDiv(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(rules="required|cnpj", v-slot="{ errors }", :name="nomeAba + '/Cnpj'")
          app-label(label="CNPJ:", :required="true")
          el-input.input(
            v-model="cadastroFormulario.cadastrante.pessoa.pessoaJuridica.cnpj",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

      el-col.inputDiv(:span="16")
        validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome/Razão social'")
          app-label(label="Razão Social:", :required="true")
          el-input.input(
            maxlength="300"
            v-model="cadastroFormulario.cadastrante.pessoa.pessoaJuridica.razaoSocial",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    app-endereco(:endereco="cadastroFormulario.cadastrante.pessoa.endereco", :estadoCadastrante="estado" nomeAba="Cadastrante")
</template>

<script>
import AppEndereco from '@/components/AppEnderecoRetificacao'
import AppLabel from '@/components/AppLabel'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AppModalTrocarTipo from '@/components/AppModalTrocarTipo'
import AppInputTelefone from '@/components/AppInputTelefoneRetificacao'

export default {

  props: {
    idProcesso: {
      required: true
    },
    observer: {
      required: true
    }
  },

  components: {
    AppEndereco,
    AppLabel,
    AppModalTrocarTipo,
    AppInputTelefone
  },

  data () {
    return {
      nomeAba: 'Cadastrante',
      funcionarioIterma: null,
      radio: null,
      cadastroFormulario: null,
      campoValor: {
        value: null,
        field: null
      },
      tipoCadastro: null,
      telefones: [],
      estado: null
    }
  },

  async created () {
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastro))
    this.radio = this.getPessoaFisicaOrJuridica(this.cadastroFormulario?.cadastrante?.pessoa)
    this.tipoCadastro = this.tipo.replace(/['"]/g, '')
    this.telefones = this.cadastroFormulario?.cadastrante?.pessoa?.telefones
  },

  methods: {
    ...mapActions('retificacao', ['update', 'updateMunicipio', 'updateObjeto']),
    ...mapActions({
      findPessoa: 'pessoa/findByCpfOrCnpj',
      findByIdCadastro: 'cadastro/findCadastroById'
    }),
    ...mapMutations('retificacao', ['CADASTRO_INICIAL', 'CHANGE_TIPO_CADASTRANTE', 'SET_FIELD_VALUE', 'SET_CAMPO_VALOR']),

    getPessoaFisicaOrJuridica (pessoa) {
      if (!pessoa?.isPessoaFisica) {
        if (pessoa?.pessoaFisica?.cpf) {
          return true
        }
        return false
      }
      return pessoa?.isPessoaFisica
    },
    changeTipoCadastrante () {
      this.estado = null
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado',
      cadastro: 'retificacao/cadastro',
      tipo: 'retificacao/tipo'
    })
  },

  watch: {
    'radio' (val) {
      if (val !== null) {
        this.CHANGE_TIPO_CADASTRANTE(val)
        this.update({ field: 'cadastrante.pessoa.isPessoaFisica', value: val })
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastro))
      }
    },
    'cadastroFormulario.cadastrante.pessoa.pessoaJuridica.cnpj' (val) {
      this.update({field: 'cadastrante.pessoa.pessoaJuridica.cnpj', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.pessoaJuridica.razaoSocial' (val) {
      this.update({field: 'cadastrante.pessoa.pessoaJuridica.razaoSocial', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.pessoaFisica.nome' (val) {
      this.update({field: 'cadastrante.pessoa.pessoaFisica.nome', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.pessoaFisica.cpf' (val) {
      this.update({field: 'cadastrante.pessoa.pessoaFisica.cpf', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.logradouro' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.logradouro', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.numero' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.numero', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.semNumero' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.semNumero', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.complemento' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.complemento', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.bairro' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.bairro', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.cep' (val) {
      this.update({field: 'cadastrante.pessoa.endereco.cep', value: val})
    },
    'cadastroFormulario.cadastrante.pessoa.endereco.municipio.nome' (val) {
      if (val && (val.codigoEstado || val.estado)) {
        const campoValor = [
          {field: 'cadastrante.pessoa.endereco.municipio.nome', value: val.nome},
          {field: 'cadastrante.pessoa.endereco.municipio.estado', value: val.codigoEstado || val.estado},
          {field: 'cadastrante.pessoa.endereco.municipio.id', value: val.id}
        ]
        this.updateObjeto({value: campoValor})
      }
    },
    'cadastroFormulario.cadastrante.pessoa.email' (val) {
      this.update({field: 'cadastrante.pessoa.email', value: val})
    }
  }
}
</script>

<style lang="scss" scoped>
.dados-cadastrante {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 50px;
    padding-top: 10px;
  }
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 100%;
  }
}
.radio-buttons {
  padding: 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/CadastranteSicarfRetificacao.vue